import CallLog from "@/interfaces/CallLog";

const LABELS: Record<CallLog["outcome"], string> = {
  ringing: "Sonne",
  in_call: "En cours",
  completed: "Terminé",
  canceled: "Annulé",
  failed: "Échoué",
};

export function callOutcomeLabel(
  call: Pick<CallLog, "outcome" | "liveEndedAt">,
): string {
  return call.liveEndedAt && ["ringing", "in_call"].includes(call.outcome)
    ? "Terminé — compte rendu attendu"
    : LABELS[call.outcome];
}
